module.exports = __webpack_public_path__ + "img/choose-up-12_3.f3d0a8a1.png";